import { gql } from '@apollo/client';
import { NEWSLETTER_FRAGMENT } from '../fragments/newsletter.newsletter.graphql';

export const GET_NEWSLETTER_QUERY = gql`
  query GetNewsletter($where: NewsletterWhereUniqueInput!) {
    newsletter(where: $where) {
      ...Newsletter
    }
  }
  ${NEWSLETTER_FRAGMENT}
`;
